var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _vm.tid } })],
      1
    ),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _vm._m(1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Configure settings")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-5 col-sm-6 text-right" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("label", { attrs: { for: "Trigger" } }, [
          _vm._v("Deletition handling:"),
        ]),
        _c("br"),
        _vm._v(" "),
        _c("div", { staticClass: "form-check form-check-inline" }, [
          _c("input", {
            staticClass: "form-check-input",
            attrs: {
              type: "radio",
              name: "inlineRadioOptions",
              id: "inlineRadio3",
              value: "option3",
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "form-check-label", attrs: { for: "inlineRadio3" } },
            [_vm._v("Ignore")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-check form-check-inline" }, [
          _c("input", {
            staticClass: "form-check-input",
            attrs: {
              type: "radio",
              name: "inlineRadioOptions",
              id: "inlineRadio3",
              value: "option3",
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "form-check-label", attrs: { for: "inlineRadio3" } },
            [_vm._v("Delete")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { attrs: { for: "Trigger" } }, [_vm._v("Error handling:")]),
        _c("br"),
        _vm._v(" "),
        _c("div", { staticClass: "form-check form-check-inline" }, [
          _c("input", {
            staticClass: "form-check-input",
            attrs: {
              type: "radio",
              name: "inlineRadioOptions",
              id: "inlineRadio3",
              value: "option3",
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "form-check-label", attrs: { for: "inlineRadio3" } },
            [_vm._v("Continue on error")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-check form-check-inline" }, [
          _c("input", {
            staticClass: "form-check-input",
            attrs: {
              type: "radio",
              name: "inlineRadioOptions",
              id: "inlineRadio3",
              value: "option3",
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "form-check-label", attrs: { for: "inlineRadio3" } },
            [_vm._v("Stop on error")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { attrs: { for: "Trigger" } }, [_vm._v("Throttling:")]),
        _c("br"),
        _vm._v(" "),
        _c("div", { staticClass: "form-check form-check-inline" }, [
          _c("input", {
            staticClass: "form-check-input",
            attrs: {
              type: "checkbox",
              name: "inlineRadioOptions",
              id: "inlineRadio3",
              value: "option3",
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "form-check-label", attrs: { for: "inlineRadio3" } },
            [_vm._v("Enable throttling")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn btn-primary btn-lg",
          attrs: { href: "/#/admin/integrations/pipelines/dashboard/1" },
        },
        [_vm._v("Save")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }